/**
 * coBrand.js — the Mach Five Marketing attribution block.
 *
 * Mach Five Magnet is a Mach Five Marketing product, and the auth surfaces are
 * where a visitor first meets it — so the co-brand leads the blue panel's
 * hero stack, above the headline: "From" + the MFM lockup, linking out to the
 * agency site. One helper so every auth route renders the identical block
 * (styles live in shared/styles/launCh.css under .auth-cobrand).
 *
 * Variants:
 *   'panel' (default) — for the blue .auth-right panel; white lockup, first
 *     child of the hero content so it sits above the eyebrow + headline.
 *   'light' — for light surfaces (the questionnaire card footer); black
 *     lockup at reduced opacity.
 */

// Vite resolves these to hashed asset URLs (base-aware).
import lockupWhite from '../../../../shared/styles/img/mfm-lockup-white.png';
import lockupBlack from '../../../../shared/styles/img/mfm-lockup-black.png';
import lockupColor from '../../../../shared/styles/img/mfm-lockup-color.png';
import magnetLockup from '../../../../shared/styles/img/m5mag-lockup.png';

const MFM_URL = 'https://www.machfivemarketing.com';

// Raw lockup URLs for surfaces that compose their own brand treatment
// (splash hero; the questionnaire fill header).
export const magnetLockupUrl = magnetLockup;
export const mfmLockupBlackUrl = lockupBlack;
export const mfmLockupColorUrl = lockupColor; // blue mark + navy wordmark, for light surfaces

/**
 * The Mach Five Magnet brand block for the auth form column: the real full
 * lockup (gradient mark + wordmark) from the brand kit, replacing the old
 * mark-plus-HTML-text combo. Same block on every auth route.
 */
export function magnetBrandHTML(href = '#/splash') {
  return `
        <a class="auth-brand" href="${href}" aria-label="Mach Five Magnet">
          <img src="${magnetLockup}" alt="Mach Five Magnet" height="42" />
        </a>`;
}

export function coBrandHTML(variant = 'panel') {
  const light = variant === 'light';
  return `
    <a class="auth-cobrand${light ? ' auth-cobrand--light' : ''}" href="${MFM_URL}"
       target="_blank" rel="noopener" aria-label="From Mach Five Marketing">
      <span class="auth-cobrand__label">From</span>
      <img class="auth-cobrand__logo" src="${light ? lockupBlack : lockupWhite}"
           alt="Mach Five Marketing" height="26" loading="lazy" />
    </a>`;
}

export default { coBrandHTML };
